module.exports = __webpack_public_path__ + "img/logo-m2n.628bae06.svg";